import React, { Component } from 'react'
import { connect } from 'react-redux';
import NewTicket from '../NewTicket/NewTicket'
import Ticket from '../Ticket/Ticket'
import Pagination from '../pagination'
import Loading from '../Loading'
import { URL_API } from "../../constants";

import { itemsFetchData, ticketsUrl } from '../../actions/index';
import * as reducers from "../../reducers/index";

import { ExpansionPanelSummary } from '@material-ui/core';

class Main extends Component {

  componentWillMount() {
    this.props.fetchData(`${URL_API}/request/?status=`);
  }

  componentDidMount() {

  }

  paginationAction = (url) => {
    this.props.fetchData(`${url}`, true);
  }

  renderModel = (id) => {
    if (!this.props.modelList || this.props.modelList.length === 0 || this.props.modelList.length === undefined) {
      return null
    }
    const result = this.props.modelList.filter(item => item.id === id)
    return result
  }
  renderProducer = (id) => {
    if (!this.props.producerList || this.props.producerList.length === 0 || this.props.producerList.length === undefined) {
      return null
    }
    const result = this.props.producerList.filter(item => item.id === id)
    return result
  }
  renderType = (id) => {
    if (!this.props.techlist || this.props.techlist.length === 0 || this.props.techlist.length === undefined) {
      return null
    }
    const result = this.props.techlist.filter(item => item.id === id)
    return result
  }

  renderStatus = (id) => {
    if (!this.props.listStatus || this.props.listStatus.length === 0 || this.props.listStatus.length === undefined) {
      return null
    }
    const result = this.props.listStatus.filter(item => item.id === id)
    return result
  }
  renderRepair = (id) => {
    let result
    if (!this.props.listRepair || this.props.listRepair.length === 0 || this.props.listRepair.length === undefined) {
      return null
    } else {
      result = this.props.listRepair.filter(item => item.id === id)
    }
    return result
  }

  render() {

    if (this.props.tickets.length !== 0 || this.props.tickets.length !== 0) {
      const ticketItems = this.props.tickets.results;
      return (
        <div style={{ marginTop: '20px' }}>
          <div className="container">

            <ExpansionPanelSummary className='waves-effect waves-orange' style={{ background: '#fff', boxShadow: '0px 1px 3px 0px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 2px 1px -1px rgba(0, 0, 0, 0.12)' }}>
              <div className="ticket__group-items">
                <div className='ticket__group-item-icon'></div>
                <div className="ticket__group-item-a">Статус</div>
                <div className="ticket__group-item-b">Тип</div>
                <div className="ticket__group-item-b">Модель</div>
                <div className="ticket__group-item-b center">Дата</div>
                <div className="ticket__group-item-icon text--left">Акт</div>
              </div>
            </ExpansionPanelSummary>

            {ticketItems.map((item) => <Ticket
              item={item}
              key={item.id}
              series={item.equip.series}
              model={this.renderModel(item.equip.model)}
              producer={this.renderProducer(item.equip.producer)}
              type={this.renderType(item.equip.type)}
              status={this.renderStatus(item.status_id)}
              repair={this.renderRepair(item.repair_id)}
            />)}

          </div>
          <div className="container">
            <Pagination
              count={this.props.tickets.count}
              next={this.props.tickets.next}
              previous={this.props.tickets.previous}
              url={this.props.tickets_url}
              action={this.paginationAction}
            />
          </div>
          <NewTicket open={this.props.open} />
        </div>
      )
    } else {
      return (<main id="main" style={{ minHeight: '100vh' }}>
        <div className="container center">
          <Loading />
        </div>
      </main>)
    }

  }
}

Main.defaultProps = {
  tickets: [],
  techlist: [],
  producerList: [],
  filters: [],
  istStatus: [],
  listRepair: []


}

const mapStateToProps = (state) => {

  return {
    tickets: state.tickets,
    techlist: state.techlist,
    tickets_url: state.tickets_url,
    hasErrored: state.ticketsHasErrored,
    isLoading: state.ticketsIsLoading,
    open: state.modalAction,
    filters: state.filters,
    listStatus: state.listStatus,
    listRepair: state.listRepair,
    producerList: state.producerList,
    modelList: state.modelList,
    isAuthenticated: reducers.isAuthenticated(state)
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchData: (url, bool = false) => {
      dispatch(itemsFetchData(url))
      if (bool === false) {
        dispatch(ticketsUrl(url))
      }
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Main);




// WEBPACK FOOTER //
// ./src/components/Main/Main.js